<template>
  <b-navbar toggleable="md" type="dark" class="navbar-dark sticky-top bg-dark">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand to="/" class="navbar-brand">
      <img src="../assets/images/giz-mono.svg" id="navbar-logo">
      ABC <span class="d-none d-sm-inline">Zusatzmaterialien</span>
    </b-navbar-brand>

    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav>
        <b-nav-item to="/home" active-class="active"><icon name="home" scale="1.2" class="symbol"></icon> Start<span class="d-inline d-md-none d-lg-inline">seite</span></b-nav-item>
        <b-nav-item to="/resources/search" active-class="active"><icon name="search" scale="1.1" class="symbol"></icon> Materialien<span class="d-inline d-md-none d-lg-inline"> suchen</span></b-nav-item>
        <b-nav-item to="/resources/list" active-class="active"><icon name="list" scale="1.1" class="symbol"></icon> Alpha 1 &amp; 2</b-nav-item>
        <b-nav-item to="/resources/topicList" active-class="active"><icon name="list" scale="1.1" class="symbol"></icon> Alpha 3 &amp; 4</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item to="/impress" active-class="active">Impressum</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
  export default {
    name: 'Navbar'
  }
</script>


<style lang="scss" scoped>
  @import '../style/bootstrap-component-include';

  .symbol {
    margin-top: -5px;
    vertical-align: middle;
  }

  .sticky-top {
    z-index: 1;
  }

  #navbar-logo {
    $navbar-logo-height: 40px;
    $navbar-logo-mb: -5px;

    margin-top: 25px - $navbar-logo-mb - $navbar-logo-height;
    height: $navbar-logo-height;
    margin-bottom: $navbar-logo-mb;
  }
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue